import { useTranslations } from 'next-intl';
import { ModalPortal } from '@/components/layout/modals/ModalPortal';
import { Button } from '@/components/ui/button/Button';
import { PATHS } from '@/constants/path';
import { useRouter } from '@/i18n/routing';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const MigrationEmailAlreadyExistsModal = ({ isOpen, onClose }: Props) => {
  const t = useTranslations();
  const { push } = useRouter();

  const handleClick = () => {
    onClose();
    push(PATHS.ROOT);
  };

  return (
    <ModalPortal
      isOpen={isOpen}
      title={t('livenode-id-migration-email-already-registered_title')}
      body={t('livenode-id-migration-email-already-registered_description')}
      PrimaryButtonComponent={() => (
        <Button label={t('common-back_to_top')} fullWidth onClick={handleClick} />
      )}
    />
  );
};
